export default {
    //api_url : 'http://localhost:8000/api/v2',
    api_url : '/api/v2',
    recaptchaSiteKey : '6LfgezUUAAAAABN9e7e9XqpJbx4blJP94qeiEmRB', // dev
}
